/* eslint-disable import/no-cycle */
import merchant from './merchant';
import aggregator from './aggregator';

const inputer = {
  namespaced: true,

  state() {
    return {};
  },

  mutations: {},

  actions: {},

  modules: {
    merchant,
    aggregator,
  },
};
export default inputer;
